/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_AttachInputs */

const en_pc_online_cmp_attach = /** @type {(inputs: Pc_Online_Cmp_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving embedded attachments`)
};

const zh_pc_online_cmp_attach = /** @type {(inputs: Pc_Online_Cmp_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存嵌入的附件`)
};

/**
* | output |
* | --- |
* | "Saving embedded attachments" |
*
* @param {Pc_Online_Cmp_AttachInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_attach = /** @type {((inputs?: Pc_Online_Cmp_AttachInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_AttachInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_attach(inputs)
	return zh_pc_online_cmp_attach(inputs)
});
export { pc_online_cmp_attach as "pc.online.cmp.attach" }